import React from "react";
import { ComponentLicensingCardCompamy } from "../../licensing/ComponentLicensingCardCompamy";
import { CompanentNoRigthLicCardCompany } from "../../licensing/CompanentNoRigthLicCardCompany";
import { DashCard } from "../../UI/DashCard";
import { SubscriptionComponentCard } from "../../subscription/SubscriptionComponentCard";
import { NoRightsMessage } from "../../UI/NoRightsMessage";
import { NumberCompany } from "../NumberCompany";
import RolesState from "../../../api/RolesState";

export function CompanyCardInfoStack() {
  return (
    <div className="info-stack">
      {RolesState.license_id ? (
        <ComponentLicensingCardCompamy />
      ) : (
        <div className="card dash-card">
          <CompanentNoRigthLicCardCompany>
            Нет прав для просмотра лицензий
          </CompanentNoRigthLicCardCompany>
        </div>
      )}

      <DashCard className="dash-card-subscription" title="Подписка и юр. лица">
        {RolesState.get_subscription_id ? (
          <SubscriptionComponentCard />
        ) : (
          <NoRightsMessage>
            Нет прав для для упралвения подписками
          </NoRightsMessage>
        )}
        <NumberCompany />
      </DashCard>
    </div>
  );
}
